import grey from '@mui/material/colors/grey';
import { red } from '@mui/material/colors';
import { defineStyle, theme } from '../theme';
import { getColorFromMuiVar } from '../utils/getColorFromMuiVar';
import { alphaBlendHex } from '../utils/alphaBlendHex';
export const cellStyle = defineStyle({
    px: ({ spacing }) => spacing(1),
    py: ({ spacing }) => spacing(0.2),
    width: 'inherit',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'pre',
});
export const rowStyle = defineStyle({
    '&:hover': {
        backgroundColor: grey[100],
    },
    '&:hover td': {
        backgroundColor: grey[100],
    },
});
const selectedBgColor = alphaBlendHex(getColorFromMuiVar(theme.vars.palette.primary.main), 0.2);
const selectedHoverBgColor = alphaBlendHex(getColorFromMuiVar(theme.vars.palette.primary.main), 0.3, '#ffffff');
export const rootStyle = defineStyle({
    ...rowStyle,
    backgroundColor: 'background.paper',
    '& td': {
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
    },
    '& td:first-of-type': {
        textAlign: 'center',
    },
});
export const selectedStyle = defineStyle({
    ...rootStyle,
    backgroundColor: selectedBgColor,
    '& td': {
        backgroundColor: selectedBgColor,
    },
    '&:hover': {
        backgroundColor: selectedHoverBgColor,
    },
    '&:hover td': {
        backgroundColor: selectedHoverBgColor,
    },
});
export const duplicityStyle = defineStyle({
    ...rootStyle,
    backgroundColor: red['100'],
    '& td': {
        backgroundColor: red['100'],
    },
    '&:hover': {
        backgroundColor: '#ffa9b2',
    },
    '&:hover td': {
        backgroundColor: '#ffa9b2',
    },
});
//# sourceMappingURL=styles.js.map